import { Component, Input } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { WindowModel } from '../../authentication.Service';
import { SurveyModel, Schedule } from '../../survey.Service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-survey-schedular',
  templateUrl: './survey-schedular.component.html',
  styleUrls: ['./survey-schedular.component.css']
})
export class SurveySchedularComponent {

  displayScheduler: boolean = false;
  windows: WindowModel[] = [];
  schedule: Schedule;
  schedules: Schedule[] = [];
  scheduleType: string = "now";
  timings: FormGroup;
  tz: number = 0;

  constructor() {
    this.timings = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
  }

  timezoneChanged($event) {

  }

  adjustTime(value: Date, offset: number) {
    let date = new Date(value);
    date.setMinutes(date.getMinutes() + offset);
    return date;
  }


  @Input()
  get survey(): SurveyModel {
    return this._survey;
  }
  set survey(value: SurveyModel) {
    this._survey = value;
    if (this._survey == undefined || this._survey == null || this.survey.JobMaster == null) {
      return;
    }

    let timezone = this.survey.JobMaster.Name;
    this.schedules = this.survey.JobMaster.Crons;
    this.tz = (this.survey.JobMaster.Start.getTimezoneOffset() ?? 0);
    this.timings.controls.start.setValue(this.adjustTime(this.survey.JobMaster.Start, this.tz));
    this.timings.controls.end.setValue(this.adjustTime(this.survey.JobMaster.End, this.tz));
    this.selectedScheduleType();
    if (this.scheduleType == "cron") {
      this.openScheduler();
    }
    else {
      this.selectNow();
    }

    this.windows = [];
    if (this.survey.Windows != undefined) {
      for (let i = 0; i < this.survey.Windows.length; i++) {
        this.windows.push(plainToClass(WindowModel, this.survey.Windows[i]));
      }
    }
  }
  private _survey: SurveyModel;

  selectNow() {
    this.displayScheduler = false;
    this.scheduleType = "now";
  }

  openScheduler() {
    this.displayScheduler = true;
    this.scheduleType = "cron";
  }

  onWindowChange(value: WindowModel[]) {
    this.windows = value;
  }

  schedulesChanged(value: any) {

  }

  selectedScheduleType() {
    if (this.survey.JobMaster) {
      if (this.survey.JobMaster.CronExpression === "") {
        this.scheduleType = "now";
      }
      else {
        this.scheduleType = "cron";
      }
    }
  }
}
